import Reports from '@pages/Reports.vue';
import ViewReport from '@pages/ViewReport.vue';
import ExportReport from '@pages/ExportReport.vue';

const permissions = [
  {
    role: 'Guest',
    access: false,
    redirect: 'Home',
  },
  {
    role: 'Member',
    access: false,
    redirect: 'Dashboard',
  },
];

export default [
  {
    path: '/reports',
    name: 'Reports',
    component: Reports,
    meta: {
      permissions: permissions,
    },
  },
  {
    path: '/reports/:id',
    name: 'ReportView',
    component: ViewReport,
    meta: {
      permissions: permissions,
    },
  },
  {
    path: '/export-report/:id',
    name: 'ExportReport',
    component: ExportReport,
    meta: {
      permissions: permissions,
    },
  },
];
